import { IProcessItem } from '../interfaces/Workflow';

export interface FlowState {
  activities: IProcessItem[];
  processes: IProcessItem[];
  loaded: {
    activities: boolean;
    processes: boolean;
  };
}

export type FlowAction =
  | { type: 'SET_ACTIVITIES'; payload: IProcessItem[] }
  | { type: 'SET_PROCESSES'; payload: IProcessItem[] }
  | { type: 'SET_LOADED'; payload: Partial<FlowState['loaded']> }
  | { type: 'RESET' };

export const initialFlowState: FlowState = {
  activities: [],
  processes: [],
  loaded: {
    activities: false,
    processes: false,
  },
};

export const flowsReducer = (
  state: FlowState,
  action: FlowAction,
): FlowState => {
  switch (action.type) {
    case 'SET_ACTIVITIES':
      return {
        ...state,
        activities: action.payload,
        loaded: { ...state.loaded, activities: true },
      };
    case 'SET_PROCESSES':
      return {
        ...state,
        processes: action.payload,
        loaded: { ...state.loaded, processes: true },
      };
    case 'SET_LOADED':
      return {
        ...state,
        loaded: { ...state.loaded, ...action.payload },
      };
    case 'RESET':
      return initialFlowState;
    default:
      return state;
  }
};
